<template>
  <div :class="bem()">
    <code>{{ route.query.code }}</code>
    <VisionButton
      :button-text="hasCopiedCode ? 'Copied' : 'Copy code'"
      size="xx-small"
      background-colour="black"
      @click="copyToClipboard(route.query.code)"
    >
      <template #content>
        <span :class="bem('btn-text')">
          <VisionIcon
            v-if="!hasCopiedCode"
            icon="copy"
            colour="white"
            size="xx-small"
          />
          <span v-if="hasCopiedCode">
            Copied
          </span>
          <span v-else>
            Copy
          </span>
        </span>
      </template>
    </VisionButton>
  </div>
</template>

<script setup>
const bem = useBEM('StravaCodeSnippet')
const route = useRoute()
const { $sentry } = useNuxtApp()
const shopifyStore = useShopifyStore()

const hasCopiedCode = ref(false)

function copyToClipboard(code) {
  hasCopiedCode.value = true
  navigator.clipboard.writeText(code)
}

onMounted(async () => {
  try {
    await shopifyStore.applyCouponCode({
      code: route.query.code,
      silent: false
    })
  } catch(e) {
    $sentry.captureException(e)
  }
})
</script>

<style lang="postcss" scoped>
.StravaCodeSnippet {
  @apply flex flex-wrap gap-x-4 gap-y-2 items-center justify-center text-xs;
}

.StravaCodeSnippet__btn-text {
  @apply flex gap-x-1 gap-y-2;
}
</style>